import Image from "next/image";

const DigitalProfessional = ({ professionalsdata }) => {
  return (
    <section className="my-[100px] sm:my-20">
      <div className="max-w-[1100px] md:mx-3 sm:mx-3 flex sm:flex-col items-center mx-auto gap-8">
        <div className="w-2/4 sm:w-full text-baseBlack">
          <p className="font-semibold text-lg text-baseBlack">
            {professionalsdata.title}
          </p>

          {professionalsdata.paragraphs.map((para, index) => {
            let highlighted = professionalsdata.highlight.reduce(
              (text, phrase) => {
                return text.replace(
                  phrase,
                  `<span class="font-semibold text-baseBlack">${phrase}</span>`
                );
              },
              para
            );

            return (
              <p
                key={index}
                className="leading-relaxed text-lg mb-5"
                dangerouslySetInnerHTML={{ __html: highlighted }}
              />
            );
          })}
        </div>

        <div className="w-2/4 sm:w-full flex justify-center">
          <Image
            src={professionalsdata.image}
            alt={professionalsdata.alt}
            width={467}
            height={407}
            className="object-contain"
            priority={true}
          />
        </div>
      </div>
    </section>
  );
};

export default DigitalProfessional;
